const ListeaCadetes = ({ items, actualiza }) => {

  const abreCadete = (cadete) => {
    actualiza(cadete);
    
  };

  return (
    <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
      <div style={{ maxWidth: "100%", overflowX: "auto", textAlign: "center" }}>
        <table style={{ width: "90%", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              <th style={{ textAlign: "center", width: "90px" }}>Promoción</th>
              <th style={{ textAlign: "center", width: "250px" }}>Cadete</th>
              <th style={{ textAlign: "center", width: "100px" }}>DNI</th>
              <th style={{ textAlign: "center", width: "100px" }}>Sede</th>
              <th style={{ textAlign: "center", width: "100px" }}>Condicion</th>
             
            </tr>
          </thead>
          <tbody>
            {items.map((cadete, index) => {
              return (
                <tr
                  key={index}
                  onClick={() => abreCadete(cadete)}
                  style={{
                    padding: "10px",
                    border: "1px solid #ddd",
                    backgroundColor: "#f9f9f9",
                    textAlign: "left",
                  }}
                >
                  <th style={{ textAlign: "center" }}>
                    {cadete.Promocions.nombre === "2025-2026" ? (
                      <span style={{ color: "red" }}>Ingreso</span>
                    ) : (
                      "2024-2025"
                    )}
                  </th>
                  <th 
                    style={{
                      maxWidth: "150px", // Cambia este valor según necesites
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                    title={`${cadete.cadeteApellido} ${cadete.cadeteNombre}`} // Muestra el nombre completo en hover
                  >
                    {cadete.cadeteApellido} {cadete.cadeteNombre}
                  </th>
                  <th>{cadete.cadeteDni}</th>
                  <th>{cadete.cadeteSede}</th>
                  <th>{cadete.cadeteCondicion}</th>
               
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ListeaCadetes;
